<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          PROFILE
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Profile' : 'Create New Profile' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon title="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="confirmSave" class="pa-5">
            <v-layout row wrap>
              <v-flex xs4 py-0>
                <ValidationProvider name="Name" rules="required">
                  <label class="darkblue--text">Profile Name</label>
                  <v-text-field
                    id="name"
                    label="Profile Name"
                    v-model="item.desc"
                    single-line
                    outlined
                    dense
                    required
                    data-vv-name="name"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs4 py-0>
                <ValidationProvider
                  name="Position"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Position</label>
                  <v-autocomplete
                    id="position"
                    single-line
                    outlined
                    dense
                    label="Select Position"
                    v-model="item.position"
                    required
                    :items="positions"
                    item-text="position"
                    return-object
                    :error-messages="errors"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs4 py-0>
                <ValidationProvider name="Division" v-slot="{ errors }">
                  <label class="darkblue--text">Division</label>
                  <v-autocomplete
                    id="division"
                    single-line
                    outlined
                    dense
                    label="Select Division"
                    v-model="item.mapping.divisi_id"
                    :items="divisions"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs4 py-0>
                <ValidationProvider name="House">
                  <label class="darkblue--text">House</label>
                  <v-autocomplete
                    id="house"
                    single-line
                    outlined
                    dense
                    label="Select House"
                    v-model="item.mapping.house_id"
                    :items="houses"
                    item-value="id"
                    item-text="name"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs4 py-0 v-if="loaded">
                <form-channel
                  @saveChannel="saveChannel"
                  :account.sync="item.accounts"
                  :channel.sync="item.channels"
                  :isFormProfile="true"
                />
              </v-flex>
              <!-- <v-flex xs4 py-0>
                <ValidationProvider name="Department" v-slot="{ errors }">
                  <label class="darkblue--text">Department</label>
                  <v-autocomplete
                    id="department"
                    single-line
                    outlined
                    dense
                    label="Select Department"
                    v-model="item.mapping.dept_id"
                    :items="departments"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex> -->
              <v-flex xs12 py-0>
                <ValidationProvider name="Brand">
                  <label class="darkblue--text">Brand</label>
                  <v-autocomplete
                    multiple
                    id="brand"
                    single-line
                    outlined
                    dense
                    label="Select Brand"
                    v-model="mappingBrand"
                    required
                    :items="brands"
                    return-object
                    item-text="name"
                    autocomplete="off"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs12 py-0>
                <ValidationProvider name="Entity">
                  <label class="darkblue--text">Entity</label>
                  <v-autocomplete
                    multiple
                    id="entity"
                    single-line
                    outlined
                    readonly
                    disabled
                    dense
                    label="Select Entity"
                    v-model="entity_id"
                    :items="entities"
                    item-value="id"
                    item-text="name"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs12 py-0 v-if="isDisabled">
                <label class="darkblue--text">Division View</label>
                <v-autocomplete
                  v-model="item.divisiViews"
                  :items="divisions"
                  dense
                  placeholder="Select Division"
                  multiple
                  single-line
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </v-flex>
              <v-flex xs12 py-0 v-if="isDisabled">
                <label class="darkblue--text">House View</label>
                <v-autocomplete
                  dense
                  v-model="item.houseViews"
                  :items="houses"
                  placeholder="Select House"
                  label="Select House"
                  multiple
                  single-line
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </v-flex>
              <v-flex xs12 py-0 v-if="isDisabled">
                <label class="darkblue--text">Group View</label>
                <v-autocomplete
                  v-model="item.groups"
                  :items="groups"
                  dense
                  placeholder="Select Group"
                  multiple
                  single-line
                  outlined
                  item-value="id"
                  item-text="name"
                />
              </v-flex>
              <v-flex xs12 py-0>
                <ValidationProvider
                  name="Permission"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Permission</label>
                  <v-autocomplete
                    v-model="item.permission"
                    :items="permissions"
                    dense
                    placeholder="Select Permission"
                    multiple
                    single-line
                    outlined
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'profile' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  type="submit"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import formChannel from '@/components/formChannel';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'form-channel': formChannel
  },
  props: ['id'],
  data() {
    return {
      loading: true,
      progressDialogLoading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'User Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Profile',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.id ? 'Edit' : 'Create',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      positions: [],
      groups: [],
      brands: [],
      divisions: [],
      houses: [],
      departments: [],
      entities: [],
      permissions: [],
      item: {
        desc: '',
        position: null,
        mapping: {
          brand_id: null,
          divisi_id: null,
          house_id: null,
          dept_id: null
        },
        mappingBrand: [],
        permission: [],
        groups: [],
        divisiViews: [],
        houseViews: [],
        channels: [],
        accounts: []
      },
      mappingBrand: [],
      entity_id: [],
      profile: {},
      loaded: false
    };
  },
  computed: {
    isDisabled() {
      return this.item.position
        ? this.item.position.position === 'Budget Owner'
          ? false
          : true
        : true;
    }
  },
  watch: {
    mappingBrand(val) {
      this.item.mappingBrand = val.map(item => item.id);
      this.entity_id = val.map(item => item.entity.id);
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    saveChannel(item) {
      this.item.accounts = item.account;
      this.item.channels = item.channel;
    },
    async getData() {
      this.clear();
      if (this.id) {
        await this.getDetail();
      }
      await this.getChannel();
      await this.getPosition();
      await this.getBrand();
      await this.getDivision();
      await this.getHouse();
      // await this.getDepartment();
      await this.getEntity();
      await this.getPermission();
      await this.getGroup();
      this.loaded = true;
    },
    async clear() {
      this.item = {
        desc: '',
        position: null,
        mapping: {
          brand_id: null,
          divisi_id: null,
          house_id: null
          // dept_id: null
        },
        mappingBrand: [],
        permission: [],
        groups: [],
        divisiViews: [],
        houseViews: [],
        channels: [],
        accounts: []
      };
      this.entity_id = [];
      this.mappingBrand = [];
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    getPosition() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('position/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.positions = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getBrand() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('brand/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.brands = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDivision() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('division/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.divisions = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getHouse() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('house/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.houses = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDepartment() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('department/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.departments = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getPermission() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('profile/getPermission')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.permissions = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getEntity() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('entity/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.entities = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      const id = this.id;
      await this.$store.dispatch('profile/detail', { id }).then(data => {
        this.progressDialogLoading = false;
        this.loading = false;
        if (data.code === 200) {
          this.item = data.data;
          this.item.permission = this.item.permission.map(item => {
            return item.id;
          });
          this.item.groups = this.item.groups.map(item => {
            return item.id;
          });
          this.item.divisiViews = this.item.divisiViews.map(item => {
            return item.id;
          });
          this.item.houseViews = this.item.houseViews.map(item => {
            return item.id;
          });
          // this.item.mappingBrand = this.item.mappingBrand.map(item => {
          //   return item.brand.id;
          // });
          // if (this.item.mapping.brand) {
          if (this.item.mappingBrand.length > 0) {
            this.mappingBrand = this.item.mappingBrand.map(item => {
              return item.brand;
            });
          } else if (this.item.mapping.brand_id) {
            this.item.mappingBrand.push(this.item.mapping.brand_id);
          }
          this.item.accounts = this.item.accounts.map(item => {
            return {
              account: {
                ...item
              },
              id: item.id,
              name: item.name
            };
          });
          this.loaded = true;
          // }
        } else {
          Swal.fire('Failed!', data.response.data.message.text_en, 'error');
        }
      });
    },
    getChannel() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('channel/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.channels = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    async confirmSave() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to save this data?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No!'
        }).then(result => {
          if (result.value) {
            this.save();
          }
        });
      }
    },
    async save() {
      this.progressDialogLoading = true;
      this.loading = true;
      let param = {
        desc: this.item.desc,
        permission: this.item.permission,
        position: {
          id: this.item.position.id,
          position: this.item.position.position
        },
        groups: this.item.groups,
        mappingBrand: this.item.mappingBrand,
        divisiViews: this.item.divisiViews,
        houseViews: this.item.houseViews,
        mapping: {
          brand_id: null,
          divisi_id: this.item.mapping.divisi_id,
          house_id: this.item.mapping.house_id
            ? this.item.mapping.house_id
            : null,
          // dept_id: this.item.mapping.dept_id,
          entity_id: this.item.mapping.entity_id
        },
        accounts:
          this.item.accounts.length > 0
            ? this.item.accounts.map(item => item.id)
            : null
      };
      if (this.id) {
        this.$store
          .dispatch('profile/update', { id: this.id, params: param })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'profile'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch('profile/create', param)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'profile'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.data.error, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    getGroup() {
      this.progressDialogLoading = true;
      this.loading = true;
      return this.$store
        .dispatch('dynamic/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.groups = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
